import { FC, useEffect, useRef } from "react";
import { Box, useTheme } from "@mui/material";
import Highcharts from "highcharts";
import { GaugeChartProps } from "@/storybook/c8r-highcharts/gauge-chart/utils/types";

export const GaugeChart: FC<GaugeChartProps> = ({ value, colors }) => {
  const { palette } = useTheme();
  const chartRef = useRef<HTMLDivElement | null>(null);

  const totalColor = colors?.total || palette.grey[200];
  const partialColor = colors?.partial || palette.info.light;

  useEffect(() => {
    if (!chartRef.current) {
      return;
    }

    // @ts-expect-error  | Something wrong with types, this is waiting for "Options" but it should be an "Element"
    Highcharts.chart(chartRef.current as HTMLDivElement, {
      chart: {
        type: "solidgauge",
      },

      title: null,

      pane: {
        center: ["50%", "70%"],
        size: "100%",
        startAngle: -90,
        endAngle: 90,
        background: {
          backgroundColor: totalColor,
          innerRadius: "85%",
          outerRadius: "100%",
          shape: "arc",
          borderRadius: "50%",
          borderColor: totalColor,
          borderWidth: 7,
        },
      },

      tooltip: {
        enabled: false,
      },

      yAxis: {
        stops: [[0, partialColor]],
        lineWidth: 0,
        tickWidth: 0,
        minorTickInterval: null,
        tickAmount: 2,
        title: {
          y: -70,
        },
        labels: {
          y: 16,
          x: 0,
          distance: -5,
        },
        min: 0,
        max: 100,
      },

      plotOptions: {
        solidgauge: {
          borderRadius: "50%",
          innerRadius: "85%",
          dataLabels: {
            y: -25,
            borderWidth: 0,
          },
        },
      },

      credits: {
        enabled: false,
      },

      series: [
        {
          data: [value],
          dataLabels: {
            format: "<div style='font-size:16px'>{point.percentage:.2f}%</div>",
          },
        },
      ],
    });
  }, [value, totalColor, partialColor]);

  return (
    <Box>
      <Box ref={chartRef} width={140} height={140} />
    </Box>
  );
};
